export const defaultConfig = {
  hero_headline: "Flowers That Speak",
  hero_subline:
    "Bespoke arrangements crafted with love for every Melbourne moment.",
  about_headline: "Our Story",
  about_text:
    "Family-run since 2008, Happy Day Flowers has been crafting bespoke arrangements from our Travancore studio.",
  delivery_headline: "Same-Day Delivery",
  contact_phone: "0432 767 401",
  contact_email: "hello@happydayflowers.com.au",
};
